/* Presentation only: Shopify retains all consent inputs and save handlers. */
(() => {
  'use strict';
  const selector = '#shopify-pc__prefs__dialog';
  const titles = { fr: 'Vos préférences cookies', en: 'Your cookie preferences', de: 'Ihre Cookie-Einstellungen', zh: 'Cookie 偏好设置' };
  function enhance(dialog) {
    if (dialog.dataset.oxCookies) return;
    const header = dialog.querySelector('header');
    const actions = dialog.querySelector('.shopify-pc__prefs__header-actions');
    const title = dialog.querySelector('#shopify-pc__prefs__header-title');
    const options = Array.from(dialog.querySelectorAll('.shopify-pc__prefs__option'));
    // Fall back to the native presentation if Shopify changes its structure.
    if (!header || !actions || !title || !options.length || options.some(option => !option.querySelector('label input') || !option.querySelector('p'))) return;
    const lang = document.documentElement.lang.toLowerCase().split('-')[0];
    if (titles[lang]) title.textContent = titles[lang];
    options.forEach(option => {
      const label = option.querySelector('label');
      const input = label.querySelector('input');
      const description = option.querySelector('p');
      const name = label.textContent.trim();
      const disclosure = document.createElement('button');
      disclosure.type = 'button';
      disclosure.className = 'ox-cookie-category';
      disclosure.textContent = name;
      description.id = `${input.id}-description`;
      description.hidden = true;
      disclosure.setAttribute('aria-expanded', 'false');
      disclosure.setAttribute('aria-controls', description.id);
      input.setAttribute('aria-label', name);
      input.setAttribute('aria-describedby', description.id);
      // Preserve the native label/input relationship and native change listeners.
      Array.from(label.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
      label.setAttribute('aria-label', name);
      const row = document.createElement('div');
      row.className = 'ox-cookie-row';
      option.insertBefore(row, label);
      row.append(disclosure, label);
      disclosure.addEventListener('click', () => {
        const expanded = disclosure.getAttribute('aria-expanded') === 'true';
        disclosure.setAttribute('aria-expanded', String(!expanded));
        description.hidden = expanded;
      });
    });
    dialog.append(actions);
    dialog.dataset.oxCookies = '1';
    // Native focusables were cached before the rows were enhanced. Use current
    // DOM order for Tab, while leaving Shopify's Escape/close handling intact.
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('button, a[href], input:not([tabindex="-1"]), [tabindex="0"]')).filter(element => !element.disabled && element.getClientRects().length);
      if (!focusable.length) return;
      event.stopImmediatePropagation();
      const index = focusable.indexOf(document.activeElement);
      if (event.shiftKey && index <= 0) {
        event.preventDefault();
        focusable[focusable.length - 1].focus();
      } else if (!event.shiftKey && (index === focusable.length - 1 || index === -1)) {
        event.preventDefault();
        focusable[0].focus();
      }
    }, true);
  }
  const existing = document.querySelector(selector);
  if (existing) enhance(existing);
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        const dialog = node.matches(selector) ? node : node.querySelector(selector);
        if (dialog) enhance(dialog);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
